import { cva } from 'class-variance-authority';

export const previewFileCardRootVariants = cva('flex items-center justify-between relative cursor-pointer', {
  variants: {
    size: {
      small: 'min-w-[72px] min-h-[72px] max-w-[72px] max-h-[72px]',
      large: 'min-w-[130px] min-h-[130px] max-w-[130px] max-h-[130px]',
    },
  },
  defaultVariants: {
    size: 'small',
  },
});

export const fileEmbedWrapperVariants = cva(
  'relative flex items-center justify-center border rounded-[6px] overflow-hidden',
  {
    variants: {
      size: {
        small: 'w-[64px] h-[64px]',
        large: 'w-[122px] h-[122px]',
      },
      isUnsupported: {
        true: 'border-none',
        false: 'border-blue-100',
      },
    },
    defaultVariants: {
      size: 'small',
      isUnsupported: false,
    },
  }
);

export const closeButtonVariants = cva(
  'flex items-center justify-center cursor-pointer absolute right-0 top-0 z-10 bg-red-500 rounded-full',
  {
    variants: {
      size: {
        small: 'w-[22px] h-[22px]',
        large: 'w-[24px] h-[24px]',
      },
    },
    defaultVariants: {
      size: 'small',
    },
  }
);
